import {
//	BrowserRouter as Router,
//	Switch,
//	Route,
//	Link,
	useRouteMatch,
	useParams,
	useLocation,
	useHistory
} from "react-router-dom";
import React, { useRef, useState, useEffect, createRef } from "react";

import * as common from "./common";

import TopNav from "./TopNav";

import {
	Alert,
	Breadcrumb,
	Button,
	Container
} from "react-bootstrap";


// Component ===================================================================

function MemberCertificationComplete ()
{
	const routeMatch = useRouteMatch();
	const location = useLocation();
	const params = useParams();
	const history = useHistory();

	//console.log( "MemberCertificationComplete > MemberCertificationComplete () routeMatch : " + JSON.stringify( routeMatch ) );
	//console.log( "MemberCertificationComplete > MemberCertificationComplete () location : " + JSON.stringify( location ) );
	//console.log( "MemberCertificationComplete > MemberCertificationComplete () params : " + JSON.stringify( params ) );

	// 遅延実行処理
	// ※ 非同期処理(awaitの記述不要)はここで実行すること … ここで実行しないと何度も実行されてしまう
	useEffect( function ()
	{
		// ページタイトル設定
		document.title = common.PAGE_TITLE + " [メンバー招待認証(完了)]";
	}, [] );

	return (
		<>

			{/* ヘッダー部 */}
			<div className="right_header bg-light">

				{/* パンくずリスト */}
				<Breadcrumb className="breadcrumb_list">
					<Breadcrumb.Item onClick={ () => history.push( "/" ) }>TOP</Breadcrumb.Item>
					<Breadcrumb.Item active>招待認証 (完了)</Breadcrumb.Item>
				</Breadcrumb>

				<TopNav />

			</div>

			{/* メイン部 */}
			<Container fluid className="main_container">

				<h4 className="mb-4">
					招待者の承認 ／ 否認 ／ 保留 (完了)
				</h4>

				{/* プログレストラッカー */}
				<Alert className="progress_tracker mb-4">
					<div>招待認証</div>
					<div>確認</div>
					<div className="active">完了</div>
				</Alert>

				<div className="mt-5">
					<span className="material-icons success_icon">check_circle_outline</span>
				</div>

				<p className="text-center">
					招待の処理を完了しました。
				</p>

				<div className="mt-5 mb-2 d-flex justify-content-center action_btn_group">
					<Button variant="secondary" onClick={ () => history.push( "/" ) }>TOP</Button>
				</div>

			</Container>

		</>
	);
}

export default MemberCertificationComplete;
